<template>
  <div id="page-reseller-profile">
    {{ /* LOADER */ }}
    <loading
        :active.sync="loader.isLoading"
        :can-cancel="false"
        :is-full-page="loader.fullPage"
        :opacity="loader.opacity"
        :color="loader.color"
    ></loading>

    {{ /* Heading page */ }}
    <div class="header-pages-block d-md-flex justify-content-between mb-md-4">
      <h5 class="">{{ $t('pages.reseller.id.titleProfile') }}</h5>
    </div>

    {{ /* Form component */ }}
    <!-- AD-83 : le formulaire n'est monté qu'une fois le revendeur chargé. Le store étant persisté,
         un montage anticipé lui passerait le revendeur PRÉCÉDEMMENT consulté et ferait pré-cocher,
         puis enregistrer, le catalogue d'un autre revendeur. -->
    <FormCrudReseller
        v-if="loaded"
        :reseller="ResellerModule.reseller"
        :id="ResellerModule.reseller.id"
        :selected-type="getSelectedType"
        :actionForm="'edit'"
    />
  </div>
</template>

<script>

import {mapState} from "vuex";

export default {
  data() {
    return {
      loader: {
        opacity: 0.9,
        isLoading: false,
        fullPage: true,
      },
      dataPage: {
        title: 'Page Profil'
      },
      loaded: false,
    }
  },
  methods: {
    /*----------------- LOADER ------------------*/
    showLoader() {
      this.loader.isLoading = true
    },
    hideLoader() {
      this.loader.isLoading = false
    },
  },
  async created() {
    this.showLoader()

    const reseller = await this.$store.dispatch('fetchReseller', this.$store.getters.getCurrentUser.id)
      .catch(() => null)

    // L'action avale ses erreurs et résout undefined : on ne monte le formulaire que sur un
    // revendeur réellement chargé. Le loader, lui, est fermé dans tous les cas.
    this.loaded = !!reseller
    this.hideLoader()

    if (!this.loaded) {
      this.$bvToast.toast(this.$t('pages.reseller.notFound'), {
        title: this.$t('common.error') + ' !',
        variant: 'danger',
        solid: true
      })
    }
  },
  computed: {
    /**
     * Set var selectedType
     */
    getSelectedType()
    {
      return (this.ResellerModule.reseller && this.ResellerModule.reseller.type) ? this.ResellerModule.reseller.type : null
    },
    ...mapState(['ResellerModule'])
  },
  components: {
    Loading: () => import('vue-loading-overlay'),
    FormCrudReseller: () => import('@/components/pages/reseller/FormCrudReseller')
  }
}
</script>
